import React from "react";
import { Route, Routes } from "react-router-dom";
import Signin from "../Pages/Signin";
import KanbanBoard from "../Pages/KanbanBoard";
import PrivateRoutes from "./PrivateRoutes";

const AllRoutes = () => {
  return (
    <Routes>
      <Route path="/"></Route>
      <Route path="/signin" element={<Signin />} />
      <Route
        path="/board"
        element={
          <PrivateRoutes>
            <KanbanBoard />
          </PrivateRoutes>
        }
      />
    </Routes>
  );
};

export default AllRoutes;
